import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { ActionTypeEnum, useCashCollectModel } from "../cashCollectModel";
import { WaitCashCollect } from './waitCollect'
import { AlreadyCashCollect } from './alreadyCollect'
import { orgService } from "../../../base/org/orgService";
import { beService } from "../../../base/be/beService";
import { dictService } from "../../../base/dict/dictService";
import { labelsType } from "../../pay/cashPayModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useGlobalModel } from "@/model/globalModel";
import useNavModel, { RouterParamType } from "@/model/navModel";

export const CashCollect = () => {
    const {
        actionType,
        setActionType,
        setOrgDs,
        setBeDs,
        setPayMethodDs,
        setPayMethodLabels,
        setUserTypeLabels,
    } = useCashCollectModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);


    const { resourceAuth, getSelectedDict } = useGlobalModel();

    useEffect(() => {
        let obj: labelsType = {}, obj1: labelsType = {};
        orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
        beService.beDs({}).then(ds => setBeDs(ds))
        dictService.accountTreeOne(DictCodeEnmu.PAY_METHOD).then(ds => { setPayMethodDs(ds) })

        getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
            obj[item.value] = item.label
        })
        getSelectedDict(DictCodeEnmu.USER_TYPE).forEach(item => {
            obj1[item.value] = item.label
        })
        setPayMethodLabels(obj);
        setUserTypeLabels(obj1);
        if (detailsInfo && detailsInfo?.id == '代收') {
            setActionType(ActionTypeEnum.WAITCOLLECT)
        } else {
            setActionType(() => {
                //所有tab权限
                let authArr = [ResourceAuthEnum.CASH_PAY_WILL, ResourceAuthEnum.CASH_PAY_DONE];
                //过滤出来所有分配的权限；
                let findAuth = resourceAuth.filter(item => authArr.indexOf(item as ResourceAuthEnum) >= 0);
                if (!findAuth.length) return ActionTypeEnum.NULL;
                switch (findAuth.length > 1 ? findAuth[1] : findAuth[0]) {
                    case ResourceAuthEnum.CASH_PAY_WILL:
                        return ActionTypeEnum.WAITCOLLECT;
                    case ResourceAuthEnum.CASH_PAY_DONE:
                        return ActionTypeEnum.ALREADYCOLLECT;
                    default:
                        return ActionTypeEnum.NULL;
                }
            })
        }
    }, []);

    const onWaitCollectList = () => {
        setActionType(ActionTypeEnum.WAITCOLLECT)
    }
    const onAlreadyCollectList = () => {
        setActionType(ActionTypeEnum.ALREADYCOLLECT)
    }
    const classname = (type: ActionTypeEnum) => {
        return 'tab-item ' + (actionType === type ? 'tab-active' : '')
    }

    const action = (
        <>
            <YhAuth resCode={ResourceAuthEnum.CASH_RECEI_WILL}>
                <Button
                    className={classname(ActionTypeEnum.WAITCOLLECT)}
                    type="link"
                    shape="round"
                    onClick={() => onWaitCollectList()}
                >
                    待收
                </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.CASH_RECEI_DONE}>
                <Button
                    className={classname(ActionTypeEnum.ALREADYCOLLECT)}
                    type="link"
                    shape="round"
                    onClick={() => onAlreadyCollectList()}
                >
                    已收
                </Button>
            </YhAuth>
        </>
    );
    /**
     * 内容区判断
     */
    const DetailDataBox = () => {
        switch (actionType) {
            case ActionTypeEnum.WAITCOLLECT:
                return <WaitCashCollect />;
            case ActionTypeEnum.ALREADYCOLLECT:
                return <AlreadyCashCollect />;
            default:
                return <></>
        }
    }

    return (
        <>
            <YhBox
                title="现金收款"
                action={action}
            />
            {actionType === ActionTypeEnum.WAITCOLLECT ? <WaitCashCollect /> : actionType === ActionTypeEnum.ALREADYCOLLECT ? <AlreadyCashCollect /> : null}
            {/* <DetailDataBox /> */}
        </>
    )
}

